module.exports = __webpack_public_path__ + "img/BG.66afeba8.svg";